// Lade-/Fehler-/Trunkierungs-Anzeige der Protokoll-Sichten — EINE Wahrheit für Chef- und Betreiber-Seite
// (Review-Fund 16.07.: der Block war copy-paste und divergierte schon im Warntext).
import { AUDIT_PAGE_LIMIT } from '@wf/shared'

export function AuditQueryState({ isLoading, isError, truncated, narrowHint }: {
  isLoading: boolean
  isError: boolean
  truncated: boolean
  /** Womit der Nutzer den Zeitraum eingrenzen kann, z. B. 'Zeitraum oder Aktions-Filter'. */
  narrowHint: string
}) {
  return (
    <>
      {truncated ? (
        <div className="wf-ztwarn" role="alert">
          <span aria-hidden="true">⚠</span>
          <span>
            Mehr als {AUDIT_PAGE_LIMIT} Einträge im Zeitraum — es wird nur der neueste Ausschnitt gezeigt. {narrowHint} enger wählen.
          </span>
        </div>
      ) : null}
      {isLoading ? <div className="muted">Protokoll wird geladen…</div> : null}
      {isError ? (
        <div className="error" role="alert">
          Protokoll konnte nicht geladen werden.
        </div>
      ) : null}
    </>
  )
}
